import { render, staticRenderFns } from "./FechaDeRegistro.vue?vue&type=template&id=17c0eedc"
import script from "./FechaDeRegistro.vue?vue&type=script&lang=js"
export * from "./FechaDeRegistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports